const MIN_WIDTH_SMALL_SCREEN = 640;
const MIN_WIDTH_MEDIUM_SCREEN = 1024;

export const isScreenSmallOrLower = (): boolean => window.innerWidth <= MIN_WIDTH_SMALL_SCREEN;

export const isScreenLargeOrHigher = (innerWidth: number): boolean => innerWidth >= MIN_WIDTH_MEDIUM_SCREEN;

export const downloadFileInNewTab = (url: string): void => {
  window.open(url, '_blank');
};
